import { type ReactNode } from 'react';
import { Shadows, View, type ViewProps, YStack } from 'smoothie';

import { getRGBA } from '../../../common/utils/colorUtils';

export interface BaseInputWidgetProps extends Omit<ViewProps, 'children'> {
    children: ReactNode;
}

export const BaseInputWidget = ({
    children,
    ...stackProps
}: BaseInputWidgetProps) => {
    return (
        <View
            pointerEvents="box-none"
            borderRadius={24}
            overflow="hidden"
            borderWidth={1}
            borderColor="$white"
            backgroundColor={getRGBA('$white', 0.9)}
            {...Shadows.CONVERSATIONAL}
            {...stackProps}
        >
            <View
                pointerEvents="none"
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                backgroundColor="rgba(255, 255, 255, 0.5)"
            />
            <YStack pointerEvents="auto" position="relative" zIndex={1}>
                {children}
            </YStack>
        </View>
    );
};
